package com.ustadmobile.core.viewmodel

import com.ustadmobile.lib.db.entities.Language

data class LanguageDetailUiState(
    val language: Language? = null
)